<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="financial_rep_tooltip_name"
      :name="financial_rep_tooltip_name" :description="financial_rep_tooltip_description" :editable="editable"></tool-tip>

    <div>
      <!-- <div v-if="duringSubmit" class="loading">
      <Loading/>
    </div> -->
      <div class="row justify-content-center">
        <div class="col-sm-6 signature_content_padding_top">
          <label for="financeOfficialName">Finance Official Name</label>
          <base-input id="financeOfficialName" :disabled="isReadOnly || isPartnerAccount"
            v-model="financialRepresentative.financeName" name="name" data-vv-as="Finance Official Name"
            v-validate="'required|max:300'" :error="getError('name')">
          </base-input>
        </div>
        <div class="col-sm-6 signature_content_padding_top">
          <label for="financeOffice">Finance Unit / Office</label>
          <base-input id="financeOffice" :disabled="isReadOnly || isPartnerAccount" data-vv-as="Finance Unit / Office"
            v-model="financialRepresentative.financeUnitOffice" name="unitOffice" v-validate="'required|max:300'"
            :error="getError('unitOffice')">
          </base-input>
          <p class="error" v-if="isRikOrEveOrder">I validate this order was non-monetary and did not require processing in the financial system of record.</p>
        <p class="error" v-if="isMonetaryOrder && isUsBuyOrder"> I validate the order has been fully disbursed in the financial system of record. </p>
        <p class="error" v-if="isMonetaryOrder && isUsSellOrder"> I validate the order has been fully collected in the financial system of record. </p>
        
      </div>
        <div class="col-sm-6 signature_content_padding_top">
          <label for="financeNation">Finance Nation / Organization</label>
          <v-select id="financeNation" :disabled="isReadOnly || isPartnerAccount"
            v-model="financialRepresentative.financeOrganizationId"
            :reduce="(organizationOption) => organizationOption.id" label="name"
            :options="financialRepresentative.organizations" name="financeNation"
            data-vv-as="Finance Nation / Organization" placeholder="Select one"
            :class="errors.has('financeNation') ? 'has-danger' : ''" v-validate="'required'"
            :error="getError('financeNation')"></v-select>
          <span v-show="errors.has('financeNation')" class="error">Finance Nation / Organization is required
          </span>
        </div>
        <div class="col-sm-6 signature_content_padding_top">
          <!-- verify Pin Code -->
         
      <verify-pin v-if="!isReadOnly" :checkForPartnerNationCondition="!checkForPartnerNationCondition" :isPartnerAccount="isPartnerAccount" :isReadOnly="isReadOnly"  v-on:pinVerify="pinVerify" />
          <AlertSignature  ref="alertFinancialRepresentativeSignatureGraphical" :headerText="'Finance Signature'"
            :module="'financialRepresentative'" :action="'getFinancialRepresentative'"
            :activeTab="financialRepresentative.financeSignature.type"
               v-on:onUpload="fileUploaded"
          :isPinVerified="isPinVerificationDone"
               :signatureData="financialRepresentative.financeSignature" :fileTypeId="financialValidationDocumentID"
            v-on:onSigned="onSigned"
            :textDisabled="isPartnerAccount || isReadOnly || !disbursingCollectionInformationStatus"
            :drawDisabled="isPartnerAccount || isReadOnly || !disbursingCollectionInformationStatus"
            :uploadDisabled="isPartnerAccount || isReadOnly || !disbursingCollectionInformationStatus"
            :certificateDisabled="isPartnerAccount || isReadOnly || !signedInWithCac || !disbursingCollectionInformationStatus"
            :isBalancePending="disbursingCollectionOutstandingBalance != 0" />
          <div v-if="hasSignatureImage()" class="container signature_content_padding_top_small signature_field">
            <div class="row justify-content-end">
              <delete-signature :headerText="'Are you sure you want to remove the Finance Signature?'" 
                :signatureId="financialRepresentative.financeSignature.signatureId"
                :fileTypeId="financialValidationDocumentID"
                :signatureType="financialRepresentative.financeSignature.type"
                :disabled="isPartnerAccount || isCompletedOrder"
                v-on:modal-closed="reloadData"></delete-signature>
            </div>
  
           <img class="image_layout" :src="financialRepresentative.financeSignature.view" height="100">
          </div>

          <div>
            <div class="signature_content_padding_top_small">
              <label for="signatureDate">Signature Date </label>
              <el-date-picker id="signatureDate"
                :disabled="isLegacyOrder || isReadOnly || isPartnerAccount || (!isRelevantDocumentUploaded && !fileUploadedBoolean)"
                v-model="financialRepresentative.financeDateSigned" type="date" :editable="false" format="dd-MMMM-yyyy"
                data-vv-as="Signature Date" name="dateSigned" :class="errors.has('dateSigned') ? 'has-danger' : ''"
                :error="getError('dateSigned')">
              </el-date-picker>
              <span v-show="errors.has('dateSigned')" class="error">Signature Date is required
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-12 signature_content_padding_top">
          <div class="pull-right">
            <base-button type="primary" :disabled="isReadOnly || isPartnerAccount" wide @click.native="submit"
              class="btn-next">Save</base-button>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
   
    
  </div>
</template>

<script>
import AlertSignature from "@/components/App/signatures/AlertSignature.vue";
import DeleteSignature from "@/components/App/signatures/DeleteSignature.vue";
import VerifyPin from '@/components/App/order/VerifyPin.vue';
import { mapGetters, mapActions } from "vuex";
import { Button } from "element-ui";
import Util from "@/util/util";
import Loading from 'src/components/LoadingPanel';
import toolTip from "../../Tooltip";
import { EventBus } from "@/event-bus.js";

export default {
  props: ["isReadOnly"],
  name: "FinancialRepresentative",
  data() {
    return {
      duringSubmit: false,
      financial_rep_tooltip_description: '',
      financial_rep_tooltip_name: '', 
      fileUploadedBoolean: false,
      isPinVerificationDone: false,
      pin: null,
      sigHasSigned: false
    };
  },
  components: {
    AlertSignature,
    Loading,
    [Button.name]: Button,
    DeleteSignature,
    toolTip,
    VerifyPin,
    EventBus
  },
  async mounted() {
  let ctx = this;

    await ctx.getAllTooltips()
    ctx.loadToolTips()
    
    EventBus.$on('doc-type-change', async() => {
      ctx.$loaderApp.addRequest();
      await ctx.getFinancialRepresentativeStatus(ctx.$route.params.id);
      ctx.$loaderApp.completeRequest();
    });
    this.getDocumentTypes()
  },
  computed: {
    ...mapGetters({
      financialRepresentative: "financialRepresentative/financialRepresentative",
      financialRepresentativeErrors: "financialRepresentative/financialRepresentativeErrors",
      preOrderStatus: "preOrderDetail/preOrderStatus",
      agreementInformationStatus: "agreementInformation/agreementInformationStatus",
      financialRepresentativeHelper: "financialRepresentative/financialRepresentativeHelper",
      isUsSellOrder: "preOrderDetail/isUsSellOrder",
      isUsBuyOrder: "preOrderDetail/isUsBuyOrder",
      documents: "documents/getDocuments",
      preOrder: "preOrderDetail/preOrder",
      isRikOrEveOrder: "preOrderDetail/isRikOrEveOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      disbursingCollectionOutstandingBalance:
      "disbursingCollectionInformation/disbursingCollectionOutstandingBalance",
      getUser: "authentication/getUser",
      orderMetadata: "orderMetadata/orderMetadata",
      disbursingCollectionInformationStatus: "disbursingCollectionInformation/disbursingCollectionInformationStatus",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable",
        documentTypes: "documents/documentTypes",
    }),
    isCompletedOrder() {
      return this.orderMetadata.orderStatus == "COMPLETED";
    },
    checkForPartnerNationCondition() {
      if (this.isPartnerAccount && this.isUsSellOrder) {
        if (this.financialRepresentative.financeDateRequested == null)
        {
          return true;
        }
          return false;
      } else if (this.isPartnerAccount && this.isUsBuyOrder) {
        return true;
        }
    },
       financialValidationDocumentID(){
     return this.documentTypes.filter((e)=> e.name ==  "FINANCIAL VALIDATION")[0].id
    },
   
    isLegacyOrder() {
      return Util.isLegacyOrder(this.orderMetadata.createDate);
    },
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    signedInWithCac() {
      return this.getUser.loginMethod == Util.LOGIN_METHOD_CAC;
    },
    isRelevantDocumentUploaded() {
       if (this.documents && this.documents.length > 0) {
        return this.documents.some(document => {
          return document.fileTypeNames.some(doc => doc === "FINANCIAL VALIDATION") ;
        });
      }
      return false
    },
    signatureDateAddedWithSignatureOrDocumentUploaded() {
      return this.isRelevantDocumentUploaded || this.hasSignatureImage() || this.signedInWithCac;
    }
  },
  methods: {
    ...mapActions({
      loadFinancialRepresentative: "financialRepresentative/getFinancialRepresentative",
      getFinancialRepresentativeStatus: "financialRepresentative/getFinancialRepresentativeStatus",
      getFinancialRepresentativeHelper: "financialRepresentative/getFinancialRepresentativeHelper",
      saveFinancialRepresentativeToServer: "financialRepresentative/saveFinancialRepresentative",
      getAllTooltips: "tooltip/getToolTips",
      getOrganizations: "financialRepresentative/getOrganizations",
      getFinancialRepresentativeSigOnly: "financialRepresentative/getFinancialRepresentativeSigOnly",
      getDisbursingCollectionInformationStatus:
        "disbursingCollectionInformation/getDisbursingCollectionInformationStatus",
      getDocumentTypes: "documents/getDocumentTypes",

    }),
    pinVerify(val, pin) {
      this.isPinVerificationDone = val;
      this.pin = pin;
    },
    loadToolTips() {
      const financialToolTip = this.toolTips.find(e => e.name === "FinancialSignatureModule")
      if (financialToolTip.status) {
        this.financial_rep_tooltip_description = financialToolTip.description ? financialToolTip.description : null
        this.financial_rep_tooltip_name = financialToolTip.name ? financialToolTip.name : null

      }
      return
    },
    async onSigned() {
      // complete the request
      this.sigHasSigned = true;
      await this.submit();
      // only pn user will use this
     
              this.pin = null;
    },
    async fileUploaded() {
      this.fileUploadedBoolean = true;
      // reload the latest signature view before the backend save;
      await this.getFinancialRepresentativeSigOnly(this.getOrderIdFromRoute);
      await this.submit();
      this.$loaderApp.completeRequest();

    },
    updateToolTip(updatedData) {
      this.loadToolTips()
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
    },
    async loaded() {
      let ctx = this;

      await this.getFinancialRepresentativeHelper(ctx.getOrderIdFromRoute);
      //.then(() => {
      const params = {
        buySell: ctx.financialRepresentativeHelper.buySell,
        countryId: ctx.financialRepresentativeHelper.countryId,
        preOrderDetailStatus: ctx.preOrderStatus,
        agreementInformationStatus: ctx.agreementInformationStatus,
      };

      await this.getOrganizations(params);
      await ctx.loadFinancialRepresentative(ctx.getOrderIdFromRoute);
      await ctx.getFinancialRepresentativeStatus(ctx.getOrderIdFromRoute);
      await ctx.getDisbursingCollectionInformationStatus(ctx.getOrderIdFromRoute);
      //});
    },

    onFinancialRepresentativeSignatureGraphicalResult: function (signatureData) {
      this.$store.dispatch("financialRepresentative/setSignature", signatureData);
    },
    hasSignatureImage() {
      return !Util.isNullOrEmpty(this.financialRepresentative.financeSignature.view);
    },
    async reloadData() {
      await this.loadFinancialRepresentative(this.getOrderIdFromRoute);
      await this.getFinancialRepresentativeStatus(this.getOrderIdFromRoute);
    },

    showFinancialRespresentativeErrors() {
      if (this.financialRepresentativeErrors.length > 0) {
        this.financialRepresentativeErrors.forEach(error => this.$toast.error(error))
      }
    },
    async submit(e) {
      var result = await this.$validator.validateAll();
      if (result) {
        //this.duringSubmit = true;
        this.$loaderApp.addRequest();
        if (!this.signatureDateAddedWithSignatureOrDocumentUploaded & this.financialRepresentative.dateSigned) {
          this.financialRepresentative.dateSigned = null;
          // this.duringSubmit = false;
          this.$loaderApp.completeRequest();
          this.$toast.error(Util.SIGNATURE_DATE_ADDED_WITHOUT_SIGNATURE_OR_DOCUMENT_UPLOADED);
        } else {
          let ctx = this;
          try {
            let data = {
              orderId: this.getOrderIdFromRoute,
              pin: (this.sigHasSigned || this.fileUploadedBoolean) ? this.pin : ''
            }
            await this.saveFinancialRepresentativeToServer(data);
            await this.getFinancialRepresentativeStatus(this.getOrderIdFromRoute);
            await this.loadFinancialRepresentative(this.getOrderIdFromRoute);
            //this.duringSubmit = false;
            this.$loaderApp.completeRequest();

            this.$toast.success("Success!!!");
          } catch (err) {
            //this.duringSubmit = false;
            this.$loaderApp.completeRequest();
            this.$toast.error(err);
          }
        }

      } else {
        this.$loaderApp.completeRequest();
        this.$toast.error("Please fill the form required fields."); //not handelled
      }
    },
     
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    //validate() {
    //    return this.$validator.validateAll().then(res => {
    //        this.$emit('on-validated', res, this.model);
    //        return res;
    //    });
    //}
  },

};
</script>

<style scopped>
.row {
  margin-right: 0px!important;
  margin-left: 0px!important;
}
</style>